import { Entity } from 'app/types-shared';

export const selectEntityFieldValues = (entity: Entity): { dataTag: string; value: string }[] => 
  Object
  .keys(entity)
  .filter(dataTag => 
    dataTag !== 'id' && entity[dataTag] && entity[dataTag][0] &&
    entity[dataTag][0].value !== undefined && entity[dataTag][0].value !== null &&
    entity[dataTag][0].value !== '')
  .map(dataTag => (
    { 
      dataTag, 
      value: entity[dataTag][0].value.toString() 
    })
  );
